import { Component } from '@angular/core';
import { InventoryService } from 'src/app/services/inventory.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { FileDTO } from 'src/app/models/FileDTO.model';
import { Alert } from 'src/app/shared/models/Alert';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import * as saveAs from 'file-saver';
import { MassImportSimsResponse } from 'src/app/models/MassImportSimsResponse';
import { InvalidCsvDataDto } from 'src/app/models/InvalidCsvDataDto';

import { CommonModule } from '@angular/common';
@Component({
    selector: 'app-inventory-mass-update-create',
    templateUrl: './inventory-mass-update-create.component.html',
    styleUrl: './inventory-mass-update-create.component.css',
    imports: [CommonModule]
})

export class InventoryMassUpdateCreateComponent {

    alert: Alert = {} as Alert;
    fileDTO: FileDTO = {} as FileDTO;

    templateHeader: string[] = [
        "Carrier", "ICCID", "IMEI", "MDN", "Modem Type", "Serial Number", "Static IP", "Username", "Username 2",
        "Custom Field 1", "Custom Field 2", "MDN Zip Code", "Rate Plan", "Assigned To", "Cost Code",
        "First Name", "Last Name", "Activation Date", "Originated From", "Status"
    ];

    selectedFile: File | null = null;
    fileError: boolean = false;
    fieldImportCompleted: boolean = false;
    fieldUpdateCompleted: boolean = false;
    fieldsCompleted: boolean = false;
    information: string = 'Create SIM';
    informationFile: string = 'Import SIMs (CSV)';
    informationFileUpdate: string = 'Update SIMs (CSV)';

    massImportInvalidSims: InvalidCsvDataDto[] = [];
    massUpdateInvalidSims: InvalidCsvDataDto[] = [];
    /**
     *
     */
    constructor(
        private alertService: AlertService,
        public permissionsService: ValidatePermissionsService,
        public inventoryService: InventoryService
    ) {
    }

    onFileSelected(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const validExtensions = ['csv', 'xlsx', 'xls'];
            const fileExtension = file.name.split('.').pop()?.toLowerCase();

            if (fileExtension && validExtensions.includes(fileExtension)) {
                this.selectedFile = file;
                this.fileError = false;
                this.fieldImportCompleted = true; // Habilitar el botón
            } else {
                this.selectedFile = null;
                this.fileError = true;
                this.fieldImportCompleted = false;
            }
        }
    }

    onFileSelectedUpdate(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            const validExtensions = ['csv', 'xlsx', 'xls'];
            const fileExtension = file.name.split('.').pop()?.toLowerCase();

            if (fileExtension && validExtensions.includes(fileExtension)) {
                this.selectedFile = file;
                this.fileError = false;
                this.fieldUpdateCompleted = true; // Habilitar el botón
            } else {
                this.selectedFile = null;
                this.fileError = true;
                this.fieldUpdateCompleted = false;
            }
        }
    }

    downloadTemplate(value: string = '') {
        const rows = [
            [...this.templateHeader],
            //['VZW', '89148000033392669999', '358030090257101', '20625', 'DEACTIVATE', 'Inventory-Shellie', '2025-04-21', 'MACHINE TO MACHINE 250MB ACCT SHR DYNAMIC']
            ['VZW', '89148000033392669909', '358030090257101', '20625', 'DEACTIVATE', 'Inventory-Shellie', '', '', '', '', '', '', 'MACHINE TO MACHINE 250MB ACCT SHR DYNAMIC', '', '', '', '', '2025-04-21', '', '']
        ];

        let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", value == 'update' ? "InventoryUpdateTemplate.csv" : "InventoryCreateTemplate.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);

    }

    downloadTemplateUpdate() {
        debugger;
        this.inventoryService.getTemplateUpdateInventory().subscribe(
            (response: ResponseDataFile) => {
                if (response) {
                    this.handleDownload(response);
                } else {
                    this.handleGetTemplateError();
                }
            },
            (error) => {
                console.error('Error al exportar el archivo Excel:', error);
            }
        );
    }

    handleDownload(data: ResponseDataFile) {
        const byteCharacters = atob(data.Data.fileContents);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: data.Data.contentType });
        saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

        this.alert = {
            alertMessage: 'File generated successfully',
            alertType: 'alert alert-success',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
        };
        localStorage.setItem('AlertObject', JSON.stringify(this.alert));
        this.alertService.updateAlertState(
            this.alert
        );
    }

    handleGetTemplateError() {
        this.alert = {
            alertMessage: 'Unexpected error. Please try again later.',
            alertType: 'alert alert-danger',
            alertCenter: false,
            alerTitle: '',
            duration: 3000
        };
        this.alertService.updateAlertState(
            this.alert
        );
    }

    importSims() {
        if (this.selectedFile) {


            const reader = new FileReader();

            reader.onload = () => {
                const fileContent = reader.result as string;

                const formFileUpdate = document.getElementById('formFileUpdate') as HTMLInputElement;
                const formFileImport = document.getElementById('formFileImport') as HTMLInputElement;

                formFileImport.value = '';
                formFileUpdate.value = '';

                this.fileDTO = {
                    fileName: this.selectedFile!.name,
                    fileContent: fileContent,
                };

                this.inventoryService.importSims(this.fileDTO).subscribe(
                    (data) => {

                        if (true) {

                            this.handleMassImportSuccess(data)
                        }
                        else {
                            //this.handleError(StatusCode)
                        }

                    },
                    (error) => {
                        this.alert = {
                            alertMessage: 'Unexpected error. Please try again later.',
                            alertType: 'alert alert-danger',
                            alertCenter: false,
                            alerTitle: '',
                            duration: 3000,
                        };
                        this.alertService.updateAlertState(this.alert);
                        this.clearFields();
                    }
                );
            };

            reader.onerror = (error) => {
                console.error('Error al leer el archivo:', error);
                this.alert = {
                    alertMessage: 'Error reading file. Please try again.',
                    alertType: 'alert alert-danger',
                    alertCenter: false,
                    alerTitle: '',
                    duration: 3000,
                };
                this.alertService.updateAlertState(this.alert);
            };

            reader.readAsText(this.selectedFile);
        }
    }

    updateSims() {
        if (this.selectedFile) {
            const reader = new FileReader();

            reader.onload = () => {
                const fileContent = reader.result as string;

                const formFileUpdate = document.getElementById('formFileUpdate') as HTMLInputElement;
                const formFileImport = document.getElementById('formFileImport') as HTMLInputElement;

                formFileImport.value = '';
                formFileUpdate.value = '';

                this.fileDTO = {
                    fileName: this.selectedFile!.name,
                    fileContent: fileContent,
                };

                this.inventoryService.updateSims(this.fileDTO).subscribe(
                    (data) => {
                        this.handleMassUpdateSuccess(data)
                    },



                    (error) => {
                        this.alert = {
                            alertMessage: 'Unexpected error. Please try again later.',
                            alertType: 'alert alert-danger',
                            alertCenter: false,
                            alerTitle: '',
                            duration: 3000,
                        };
                        this.alertService.updateAlertState(this.alert);
                        this.clearFields();
                    }
                );
            };

            reader.onerror = (error) => {
                console.error('Error al leer el archivo:', error);
                this.alert = {
                    alertMessage: 'Error reading file. Please try again.',
                    alertType: 'alert alert-danger',
                    alertCenter: false,
                    alerTitle: '',
                    duration: 3000,
                };
                this.alertService.updateAlertState(this.alert);
            };

            reader.readAsText(this.selectedFile);
        }
    }

    async handleMassImportSuccess(data: MassImportSimsResponse) {
        if (data.validationErrorMessage) {

            this.alertService.error(data.validationErrorMessage);

        }
        else if (data.invalidSims && data.invalidSims.length > 0) {
            this.massImportInvalidSims = data.invalidSims
            //this.alertService.error(data.invalidSims[0].validationErrorMessage);
        }
        else {

            this.alertService.success('SIMs saved successfully');

            this.massImportInvalidSims = [];
            //this.clearFields();
            location.reload();
        }
    }

    async handleMassUpdateSuccess(data: MassImportSimsResponse) {
        if (data.validationErrorMessage) {
            this.alertService.error(data.validationErrorMessage);
        }
        else if (data.invalidSims && data.invalidSims.length > 0) {
            this.massUpdateInvalidSims = data.invalidSims
        }
        else {

            this.alertService.success('SIMs saved successfully');

            this.massUpdateInvalidSims = [];
            //this.clearFields();
            location.reload();
        }
    }

    handleError(StatusCode: number) {
        this.clearFields();
    }

    clearFields() { }

    downloadthisMassImportInvalidSims() {

        const rows = [
            [...this.templateHeader, 'Error'],

        ];

        const data = this.massImportInvalidSims.map(item => {
            let row: string[] = item.rawData?.split(',') as string[]
            row?.push(item.validationErrorMessage as string);
            return row;
        });

        rows.push(...data as any)

        let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "MassImportInvalidSims.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
    }

  downloadMassUpdateInvalidSims(){
   
    
    let rows = []

        const errorHeader = [...this.templateHeader, 'ValidationErrorMessage'].join(",")
        rows.push(errorHeader)




        const data = this.massUpdateInvalidSims.map(item => {
            let row: string[] = item.rawData?.split(',') as string[]
            row?.push(item.validationErrorMessage as string);
            return row.join(",");
        })
        rows.push(...data as any)

        let csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "MassUpdateInvalidSims.csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        document.body.removeChild(link);
    }
}
